import {getTodayStartTime, inRange} from 'shared/utils/dateTime';
import {useBudgetStore} from 'store/Budget';
import {useMoneyLeft} from 'ui/utils/core';

export function useMoneyOverDetector(): boolean {
  const moneyLeft = useMoneyLeft();
  return moneyLeft <= 0;
}

export function useTimeOverDetector(): boolean {
  const {startDate, finishDate} = useBudgetStore();
  const today = getTodayStartTime();
  return !inRange(today, startDate, finishDate);
}
